// import "./App.css";
// import "./style/globals.scss";
import React, { useRef, useState } from "react";
import { Col, Container, Navbar, Row } from "react-bootstrap";
import Lottie from "react-lottie-player";
import ScrollToActive from "./WebComponent/ScrollToActive";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectFade, Autoplay } from "swiper/modules";
import Loading from "./Component/Loading";
import { isIOS, isAndroid } from "react-device-detect";
import { useEffect } from "react";
import Header from "./next-component/Header";
import Footer from "./next-component/footer";
import NoSsr from "./next-component/NoSsr";
import { Link } from "react-router-dom";

const createAnimation = (setIsLoading) => {
  setIsLoading(false);
};

const Demo = () => {
  //   const currentYear = new Date().getFullYear();
  //   const [headerClass, setHeaderClass] = useState("scroll-off");
  const [showButton, setShowButton] = useState(false);
  //   const activeSection = ScrollToActive();
  const [isLoading, setIsLoading] = useState(true);
  const [ishide, setIsHide] = useState(true);
  const [activeIndex, setActiveIndex] = useState(0);
  const swiperRef = useRef(null);

  const handleListClick = (slideIndex) => {
    setActiveIndex(slideIndex);
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slideToLoop(slideIndex); // Ensures loop compatibility
    }
  };
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    const backScroll = () => {
      if (window.scrollY > 100) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    };

    window.addEventListener("scroll", backScroll);

    return () => {
      window.removeEventListener("scroll", backScroll);
    };
  }, []);

  return (
    <>
      {isLoading && <Loading />}
      <Header />
      <div className="w-fieldcalc">
        <section className="w-hero" id="home">
          <Container>
            <Row className="g-0 align-items-center justify-content-center">
              <Col xs={12}>
                <div className="hero-content">
                  <h1>
                    GPS Area Measure <span>- FieldCalc</span>
                  </h1>
                  <p>
                    Accurately calculate field area measurements, measure
                    distances,
                    <br /> and plan efficient routes with GPS maps.
                  </p>
                  <div className="hero-btn">
                    <a
                      className="me-2"
                      target="_blank"
                      href="https://play.google.com/store/apps/details?id=com.voice.gps.navigation.map.location.route&hl=en_IN"
                      rel="noreferrer"
                    >
                      <img
                        src="/hero/playstore.svg"
                        alt="playstore-image"
                        className="img-fluid"
                      />
                    </a>
                    <a
                      className="ms-2"
                      target="_blank"
                      href="https://apps.apple.com/us/app/gps-fields-area-measure-on-map/id1238984272"
                      rel="noreferrer"
                    >
                      <img
                        src="/hero/appstore.svg"
                        alt="appstore"
                        className="img-fluid"
                      />
                    </a>
                  </div>
                </div>
              </Col>
              <Col xl={10} lg={12}>
                <div className="hero-media">
                  <img
                    src="/hero/left.svg"
                    alt=""
                    className="hms-1 img-fluid"
                  />
                  <img
                    src="/hero/center.svg"
                    alt=""
                    className="hms-2 img-fluid"
                  />
                  <img
                    src="/hero/right.svg"
                    alt=""
                    className="hms-3 img-fluid"
                  />
                  <div className="hero-animation">
                    <Lottie
                      onLoad={() => {
                        createAnimation(setIsLoading);
                      }}
                      loop
                      path="/hero/location-pin.json"
                      play
                      className="lottie-player has-1"
                    />
                    <Lottie
                      onLoad={() => {
                        createAnimation(setIsLoading);
                      }}
                      loop
                      path="/hero/location-pin.json"
                      play
                      className="lottie-player has-2"
                    />
                    <Lottie
                      onLoad={() => {
                        createAnimation(setIsLoading);
                      }}
                      loop
                      path="/hero/location-pin.json"
                      play
                      className="lottie-player has-3"
                    />
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
          <div className="hero-shape">
            <img src="/hero/1.svg" alt="" className="hshape hs-1 img-fluid" />
            <img src="/hero/2.svg" alt="" className="hshape hs-2 img-fluid" />
            <img src="/hero/3.svg" alt="" className="hshape hs-3 img-fluid" />
            <img src="/hero/4.svg" alt="" className="hshape hs-4 img-fluid" />
            <img src="/hero/5.svg" alt="" className="hshape hs-5 img-fluid" />
            <img src="/hero/6.svg" alt="" className="hshape hs-6 img-fluid" />
          </div>
        </section>
        <section className="w-appinfo pt-0">
          <Container>
            <div className="title">
              <h2>Users & Rating</h2>
              <p>
                Many happy users have downloaded our app
                <br /> and are enjoying it.
              </p>
            </div>
            <Row className="align-items-center justify-content-center g-3 g-sm-4">
              <Col xl={3} lg={4} sm={6} className="order-2 order-lg-1">
                <div className="appinfo-content">
                  <h3>10M+ Users</h3>
                  <p>
                    Our app is a top choice for GPS area measurement, helping
                    users easily measure field areas & distances using gps maps.
                  </p>
                </div>
              </Col>
              <Col xl={6} lg={4} sm={12} className="order-1 order-lg-2">
                <div className="appinfo-media">
                  <img
                    src="/appinfo/appinfo.svg"
                    alt="Downloads & Rating"
                    className="img-fluid"
                  />
                </div>
              </Col>
              <Col xl={3} lg={4} sm={6} className="order-3 order-lg-3">
                <div className="appinfo-content">
                  <h3>4.8 Rating</h3>
                  <p>
                    Rated 4.8 stars, this app is ideal for accurate field and
                    area measurements using GPS.
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <section className="w-about" id="about">
          <Container>
            <Row className="align-items-center g-3 g-sm-4">
              <Col lg={5} md={5}>
                <div className="about-media">
                  <img
                    src="/about/about.png"
                    className="img-fluid"
                    alt="About GPS Area Measure - FieldCalc"
                  />
                </div>
              </Col>
              <Col lg={7} md={7}>
                <div className="about-content">
                  <h3>
                    About GPS Area Measure <span>- FieldCalc</span>
                  </h3>
                  <p>
                    Measure fields, and distances with GPS area measurement app,
                    and save your data. Discover nearby places and plan routes
                    with the location finder. Get your live location’s address,
                    latitude, and longitude instantly. Capture images with date,
                    time, and address stamps using the GPS Camera. Track your
                    travel with the speedometer for speed and distance. Use
                    various compass modes for enhanced navigation.
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <section className="w-features" id="features">
          <Container>
            <div className="title">
              <h2>
                Key Features Of GPS Area Measure <span>- FieldCalc</span>
              </h2>
              <p>
                Discover how GPS Field Area Measurement makes land measurement
                and navigation effortless.
              </p>
            </div>
            <Row className="g-sm-4 g-3">
              <Col lg={4} sm={6}>
                <div className="features-card fb-1">
                  <img
                    src="/features/1.svg"
                    className="img-fluid"
                    alt="Field Area Measure"
                    title="Field Area Measure"
                  />
                  <div className="features-card-body">
                    <h3>Field Area Measure</h3>
                    <p>
                      Easily calculate and measure the area of any field, farm,
                      lawn, or plot with accurate GPS measurements with our GPS
                      field area calculator.
                    </p>
                  </div>
                </div>
              </Col>
              <Col lg={4} sm={6}>
                <div className="features-card fb-2">
                  <img
                    src="/features/2.svg"
                    className="img-fluid"
                    alt="Distance Measure"
                    title="Distance Measure"
                  />
                  <div className="features-card-body">
                    <h3>Distance Measure</h3>
                    <p>
                      Easily measure the distance between two points on the GPS
                      map with our user-friendly tool. Ideal for measuring
                      fencing, roads, or paths.
                    </p>
                  </div>
                </div>
              </Col>
              <Col lg={4} sm={6}>
                <div className="features-card fb-3">
                  <img
                    src="/features/3.svg"
                    className="img-fluid"
                    alt="Map Field Measurement"
                    title="Map Field Measurement"
                  />
                  <div className="features-card-body">
                    <h3>Map Field Measurement</h3>
                    <p>
                      Draw on the map to easily measure areas. Ideal for
                      calculating irregular shapes, whether for farming,
                      construction, or land assessments.
                    </p>
                  </div>
                </div>
              </Col>

              <Col lg={4} sm={6}>
                <div className="features-card fb-4">
                  <img
                    src="/features/4.svg"
                    className="img-fluid"
                    alt="GPS Navigation & Camera"
                    title="GPS Navigation & Camera"
                  />
                  <div className="features-card-body">
                    <h3>GPS Navigation & Camera</h3>
                    <p>
                      Navigate with voice guidance and find nearby places like
                      ATMs and fuel stations. Capture photos with stamps for
                      easy location tracking.
                    </p>
                  </div>
                </div>
              </Col>
              <Col lg={4} sm={6}>
                <div className="features-card fb-5">
                  <img
                    src="/features/5.svg"
                    className="img-fluid"
                    alt="Route Planner"
                    title="Route Planner"
                  />
                  <div className="features-card-body">
                    <h3>Route Planner</h3>
                    <p>
                      Find and plan your route efficiently, optimizing travel
                      paths to ensure you take the best route for the fastest
                      and most convenient journey.
                    </p>
                  </div>
                </div>
              </Col>
              <Col lg={4} sm={6}>
                <div className="features-card fb-6">
                  <img
                    src="/features/6.svg"
                    className="img-fluid"
                    alt="Sync Now"
                    title="Sync Now"
                  />
                  <div className="features-card-body">
                    <h3>Sync Now</h3>
                    <p>
                      Sync your data instantly to keep all information updated
                      and easily accessible, ensuring a smooth and uninterrupted
                      navigation experience.
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
          <div className="w-shape">
            <img
              src="/features/shape.svg"
              alt="shape"
              className="img-fluid shape-left"
            />
            <img
              src="/features/shape.svg"
              alt="shape"
              className="img-fluid shape-right"
            />
          </div>
        </section>
        <section className="w-screen" id="screens">
          <Container>
            <div className="title">
              <h2>
                Explore our<span> Amazing Interface</span>
              </h2>
              <p>
                Quickly explore the app's features and see how easily it works.
              </p>
            </div>
            <Row className="g-sm-4 g-3">
              <Col xs={12}>
                <Swiper
                  ref={swiperRef}
                  spaceBetween={0}
                  slidesPerView={5}
                  className="mySwiper"
                  roundLengths={true}
                  centeredSlides={true}
                  loop={true}
                  autoplay={{
                    delay: 2500,
                    disableOnInteraction: false,
                  }}
                  modules={[Autoplay]}
                  breakpoints={{
                    0: {
                      slidesPerView: 1,
                    },
                    576: {
                      slidesPerView: 2.5,
                    },
                    768: {
                      slidesPerView: 3,
                    },
                    1399: {
                      slidesPerView: 5,
                    },
                  }}
                >
                  <SwiperSlide>
                    <img
                      src="/screen/1.png"
                      alt="Awesome Interface"
                      className="img-fluid m-auto"
                    />
                  </SwiperSlide>
                  <SwiperSlide>
                    <img
                      src="/screen/2.png"
                      alt="Awesome Interface"
                      className="img-fluid m-auto"
                    />
                  </SwiperSlide>
                  <SwiperSlide>
                    <img
                      src="/screen/3.png"
                      alt="Awesome Interface"
                      className="img-fluid m-auto"
                    />
                  </SwiperSlide>
                  <SwiperSlide>
                    <img
                      src="/screen/4.png"
                      alt="Awesome Interface"
                      className="img-fluid m-auto"
                    />
                  </SwiperSlide>
                  <SwiperSlide>
                    <img
                      src="/screen/5.png"
                      alt="Awesome Interface"
                      className="img-fluid m-auto"
                    />
                  </SwiperSlide>
                  <SwiperSlide>
                    <img
                      src="/screen/6.png"
                      alt="Awesome Interface"
                      className="img-fluid m-auto"
                    />
                  </SwiperSlide>
                  <SwiperSlide>
                    <img
                      src="/screen/7.png"
                      alt="Awesome Interface"
                      className="img-fluid m-auto"
                    />
                  </SwiperSlide>
                </Swiper>
              </Col>
            </Row>
          </Container>
        </section>
        <section className="w-how-works" id="howitworks">
          <Container>
            <div className="title">
              <h2>
                How to use the <span>GPS Field Area Measurement App</span>
              </h2>
              <p>
                Step-by-Step Guide to Using the GPS Field Area Measurement App
              </p>
            </div>
            <Row className="justify-content-center">
              <Col xl={11}>
                <Row className="align-items-center g-3 g-sm-4">
                  <Col lg={7}>
                    <div className="work-list-container">
                      <ul id="work-list">
                        <li
                          data-slide="01"
                          className={activeIndex === 0 ? "active" : ""}
                        >
                          <div className="work-list-content">
                            <h4 onClick={() => handleListClick(0)}>
                              Open App & Start Measuring
                            </h4>
                            <p>
                              Open the app, tap "Create New," and select Measure
                              Field, Distance, or Marker. The app will calculate
                              the field or area automatically.
                            </p>
                          </div>
                        </li>
                        <li
                          data-slide="02"
                          className={activeIndex === 1 ? "active" : ""}
                        >
                          <div className="work-list-content">
                            <h4 onClick={() => handleListClick(1)}>
                              Group your measurements
                            </h4>
                            <p>
                              Create measurement groups and assign colors to
                              them for easy identification. You can easily add,
                              hide, or delete groups as needed.
                            </p>
                          </div>
                        </li>
                        <li
                          data-slide="03"
                          className={activeIndex === 2 ? "active" : ""}
                        >
                          <div className="work-list-content">
                            <h4 onClick={() => handleListClick(2)}>
                              GPS Map Camera
                            </h4>
                            <p>
                              Add custom stamps with date, time, location, and
                              notes to your photos, ensuring important details
                              are recorded for easy reference.
                            </p>
                          </div>
                        </li>
                        <li
                          data-slide="04"
                          className={activeIndex === 3 ? "active" : ""}
                        >
                          <div className="work-list-content">
                            <h4 onClick={() => handleListClick(3)}>
                              Find And Plan Your Route
                            </h4>
                            <p>
                              Easily find and plan the best route with GPS maps,
                              ensuring a quicker, more convenient journey to
                              your destination.
                            </p>
                          </div>
                        </li>
                        <li
                          data-slide="05"
                          className={activeIndex === 4 ? "active" : ""}
                        >
                          <div className="work-list-content">
                            <h4 onClick={() => handleListClick(4)}>
                              Hare Your Location
                            </h4>
                            <p>
                              With just a single click, you can instantly send
                              your real-time location to anyone, making it
                              easier than ever to share where you are.
                            </p>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </Col>
                  <Col lg={5}>
                    <Swiper
                      ref={swiperRef}
                      loop={true}
                      effect={"fade"}
                      autoplay={{
                        delay: 2500,
                        pauseOnMouseEnter: true,
                        disableOnInteraction: false,
                      }}
                      modules={[EffectFade, Autoplay]}
                      onSlideChange={(swiper) =>
                        setActiveIndex(swiper.realIndex)
                      }
                      className="swiper-container"
                    >
                      <SwiperSlide>
                        <div className="work-media">
                          <img
                            src="/screen/8.png"
                            className="img-fluid"
                            alt="Slide 1"
                          />
                        </div>
                      </SwiperSlide>
                      <SwiperSlide>
                        <div className="work-media">
                          <img
                            src="/screen/9.png"
                            className="img-fluid"
                            alt="Slide 2"
                          />
                        </div>
                      </SwiperSlide>
                      <SwiperSlide>
                        <div className="work-media">
                          <img
                            src="/screen/10.png"
                            className="img-fluid"
                            alt="Slide 3"
                          />
                        </div>
                      </SwiperSlide>
                      <SwiperSlide>
                        <div className="work-media">
                          <img
                            src="/screen/11.png"
                            className="img-fluid"
                            alt="Slide 4"
                          />
                        </div>
                      </SwiperSlide>
                      <SwiperSlide>
                        <div className="work-media">
                          <img
                            src="/screen/12.png"
                            className="img-fluid"
                            alt="Slide 5"
                          />
                        </div>
                      </SwiperSlide>
                    </Swiper>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </section>
        <section className="w-step">
          <Container>
            <div className="title">
              <h2>
                Why Choose the <span>GPS Area Measure - FieldCalc?</span>
              </h2>
              <p>
                Discover why GPS Field Area Measurement is your go-to app for
                accurate measurements.
              </p>
            </div>
            <Row className="justify-content-center g-3 g-sm-4">
              <Col lg={4} sm={6} className="step step-1">
                <div className="step-box">
                  <span>01</span>
                  <h3>Field Area Measurement</h3>
                  <p>
                    Effortlessly calculate and measure land areas using GPS
                    technology, ideal for farming, construction, property
                    assessments, land surveying, real estate planning, and
                    environmental monitoring.
                  </p>
                </div>
              </Col>
              <Col lg={4} sm={6} className="step step-2">
                <div className="step-box">
                  <span>02</span>
                  <h3>Distance Measurement</h3>
                  <p>
                    Quickly measure the distance between two points on the GPS
                    map, perfect for tracking roads, paths, fences, property
                    boundaries, planning new structures, or mapping land for
                    development.
                  </p>
                </div>
              </Col>
              <Col lg={4} sm={6} className="step step-3">
                <div className="step-box">
                  <span>03</span>
                  <h3>Route Planning & Navigation</h3>
                  <p>
                    Plan your route with voice-guided GPS to find nearby places
                    like ATMs, fuel stations, hospitals, restaurants, parking,
                    restrooms, and grocery stores for a smoother, stress-free
                    journey.
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <section className="w-download">
          <Container>
            <div className="download-box">
              <div className="shape">
                <img
                  src="/download/1.svg"
                  alt=""
                  className="img-fluid shape-1"
                />
                <img
                  src="/download/2.svg"
                  alt=""
                  className="img-fluid shape-2"
                />
                <img
                  src="/download/3.svg"
                  alt=""
                  className="img-fluid shape-3"
                />
              </div>
              <Row className="align-items-center justify-content-center g-3 g-sm-4">
                <Col lg={8}>
                  <div className="download-content">
                    <h2>Get Started Today</h2>
                    <p>
                      Easily measure fields, distances, and place markers with
                      real-time calculations. Plan routes, capture
                      location-stamped photos, and sync your data for secure
                      access and organization. Everything you need in one app to
                      make your measurements accurate and your navigation
                      effortless.
                    </p>
                    <div className="download-app-btn">
                      <a
                        className="me-2"
                        target="_blank"
                        href="https://play.google.com/store/apps/details?id=com.voice.gps.navigation.map.location.route&hl=en_IN"
                        rel="noreferrer"
                      >
                        <img
                          src="/download/playstore.png"
                          className="img-fluid"
                          alt="playstore"
                        />
                      </a>
                      <a
                        className="ms-2"
                        target="_blank"
                        href="https://apps.apple.com/us/app/gps-fields-area-measure-on-map/id1238984272"
                        rel="noreferrer"
                      >
                        <img
                          src="/download/appstore.png"
                          className="img-fluid"
                          alt="appstore"
                        />
                      </a>
                    </div>
                  </div>
                </Col>
              </Row>
              <div className="shape">
                <img
                  src="/download/4.svg"
                  alt=""
                  className="img-fluid shape-4"
                />
                <img
                  src="/download/5.svg"
                  alt=""
                  className="img-fluid shape-5"
                />
                <img
                  src="/download/6.svg"
                  alt=""
                  className="img-fluid shape-6"
                />
              </div>
            </div>
          </Container>
        </section>
        <section className="w-review" id="reviews">
          <Container>
            <div className="title">
              <h2>
                Our <span>User</span> Feedback
              </h2>
              <p>
                See how the GPS Field Area Measurement app is changing the way
                users measure and navigate.
              </p>
            </div>
            <Row className="justify-content-center g-3 g-sm-4">
              <Col lg={4} sm={6}>
                <div className="review-content">
                  <div className="review-star">
                    <i className="bx bxs-star fill"></i>
                    <i className="bx bxs-star fill"></i>
                    <i className="bx bxs-star fill"></i>
                    <i className="bx bxs-star fill"></i>
                    <i className="bx bxs-star fill"></i>
                  </div>
                  <h4>Perfect for Land Measurements</h4>
                  <p>
                    This GPS Field Area Measurement app is perfect for
                    calculating the area of my farm fields. The distance measure
                    and map field measurement features make land planning easy,
                    accurate, and efficient for my daily tasks!
                  </p>
                  <div className="review-user">
                    <img src="/review/1.png" alt="John D. - Farmer" />
                    <div className="review-user-details">
                      <h4>John D. - Farmer</h4>
                      <span>October 10, 2024</span>
                    </div>
                  </div>
                </div>
              </Col>
              <Col lg={4} sm={6}>
                <div className="review-content">
                  <div className="review-star">
                    <i className="bx bxs-star fill"></i>
                    <i className="bx bxs-star fill"></i>
                    <i className="bx bxs-star fill"></i>
                    <i className="bx bxs-star fill"></i>
                    <i className="bx bxs-star fill"></i>
                  </div>
                  <h4>Accurate GPS Field Calculator</h4>
                  <p>
                    The GPS field area calculator helps me measure land
                    accurately, and the route planner ensures I find the best
                    paths for development. The GPS navigation and photo stamps
                    are a great addition, making my work more organized!
                  </p>
                  <div className="review-user">
                    <img
                      src="/review/2.png"
                      alt="Sarah P. - Property Developer"
                    />
                    <div className="review-user-details">
                      <h4>Sarah P. - Property Developer</h4>
                      <span>October 12, 2024</span>
                    </div>
                  </div>
                </div>
              </Col>
              <Col lg={4} md={6}>
                <div className="review-content">
                  <div className="review-star">
                    <i className="bx bxs-star fill"></i>
                    <i className="bx bxs-star fill"></i>
                    <i className="bx bxs-star fill"></i>
                    <i className="bx bxs-star fill"></i>
                    <i className="bx bxs-star fill"></i>
                  </div>
                  <h4>Efficient GPS Navigation & Planning</h4>
                  <p>
                    The GPS navigation with voice guidance is spot-on, and I can
                    quickly find nearby ATMs and fuel stations. The sync feature
                    ensures all my route data and measurements are always up to
                    date, making every trip hassle free!
                  </p>
                  <div className="review-user">
                    <img src="/review/3.png" alt="Mark T. - Commuter" />
                    <div className="review-user-details">
                      <h4>Mark T. - Commuter</h4>
                      <span>October 14, 2024</span>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
          <div className="w-shape">
            <img
              src="/review/quote-left.svg"
              className="img-fluid shape-left"
              alt="shape-left"
            />
            <img
              src="/review/quote-right.svg"
              className="img-fluid shape-right"
              alt="shape-right"
            />
          </div>
        </section>

        <NoSsr>
          {ishide && isIOS && (
            <div className="downloadapp d-lg-none">
              <div className="d-flex align-items-center">
                <i
                  className="bx bx-x dappclose"
                  onClick={() => setIsHide(false)}
                ></i>
                <img
                  src="/appnotification/logoappstore.svg"
                  alt="Appstore"
                  title="Appstore"
                  className="dapplogo"
                />
              </div>
              <Link
                href="https://apps.apple.com/us/app/gps-fields-area-measure-on-map/id1238984272"
                target="_blank"
                className="gettheapp"
              >
                <img
                  src="/appnotification/appstore.svg"
                  alt="Appstore"
                  title="Appstore"
                />
              </Link>
            </div>
          )}

          {ishide && isAndroid && (
            <div className="downloadapp d-lg-none">
              <div className="d-flex align-items-center">
                <i
                  className="bx bx-x dappclose"
                  onClick={() => setIsHide(false)}
                ></i>
                <img
                  src="/appnotification/logoplaystore.svg"
                  alt="Playstore"
                  title="Playstore"
                  className="dapplogo"
                />
              </div>
              <Link
                href="https://play.google.com/store/apps/details?id=com.voice.gps.navigation.map.location.route&hl=en_IN"
                target="_blank"
                className="gettheapp"
              >
                <img
                  src="/appnotification/playstore.svg"
                  alt="Playstore"
                  title="Playstore"
                />
              </Link>
            </div>
          )}
        </NoSsr>
        {showButton && (
          <div id="back-to-top" onClick={scrollToTop}>
            <i className="bx bxs-up-arrow-alt"></i>
          </div>
        )}
      </div>
      <Footer />
    </>
  );
};

export default Demo;
